/* eslint-disable import/prefer-default-export */
export const statusLabelClass: { [key in 'CANCELED' | 'ENDED' | 'NEW' | 'ONGOING' | 'UPCOMING']?: string } = Object.freeze({
  CANCELED: 'danger',
  ENDED: 'secondary',
  NEW: 'info',
  ONGOING: 'warning',
  UPCOMING: 'success',
});
